import React from "react";
import { Box, Typography } from "@mui/material";
import GradientIcon from "../../components/GradientIcon";

const gradientHoverSx = {
  position: "relative",
  border: "2px solid transparent",
  backgroundClip: "padding-box",
  transition: "all 0.3s ease",
  "&:hover::before": {
    opacity: 1,
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "24px",
    padding: "2px",
    background: "linear-gradient(90deg, #FF7FAC, #5834BA)",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    opacity: 0,
    transition: "opacity 0.3s ease",
  },
};

export default function ContainerTmpCard({ title, description, icon }) {
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FFFFFF",
        borderRadius: "24px",
        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
        px: "24px",
        py: "48px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "24px",
        ...gradientHoverSx,
      }}
    >
      <GradientIcon
        icon={icon}
        size={40}
        bordered
        boxSize={80}
        borderRadius={24}
        borderWidth={2}
        angle="90"
        sx={{ margin: "0 auto 16px" }}
      />
      <Box>
        <Typography
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            mb: 1,
            color: "#000000",
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "1rem",
            fontWeight: 400,
            color: "#666666",
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
